import React, { forwardRef } from 'react';

export interface ContainerProps extends React.HTMLAttributes<HTMLElement> {
    /** Container max-width variant */
    size?: 'default' | 'lg' | 'measure';
    /** HTML element to render as */
    as?: 'div' | 'section' | 'article' | 'main';
}

const sizeStyles = {
    default: 'max-w-container',
    lg: 'max-w-container-lg',
    measure: 'max-w-measure',
};

/**
 * Reusable Container component for consistent max-width and padding.
 * Provides responsive horizontal padding and centers content.
 */
export const Container = forwardRef<any, ContainerProps>(({
    size = 'default',
    children,
    className = '',
    as: Component = 'div',
    ...props
}, ref) => {
    return (
        <Component
            ref={ref}
            className={`${sizeStyles[size]} mx-auto px-5 ${className}`}
            {...props}
        >
            {children}
        </Component>
    );
});

Container.displayName = 'Container';
